/**
 * The till at an old address: moves itself once its sales are uploaded, and
 * says so while it waits. See core/move.ts for why it cannot move sooner.
 */
import { useEffect, useState } from 'react';
import { db } from '../db.js';
import { thisShop } from '../shop.js';
import { moveIfRehomed, type MoveState } from '../move.js';
import { useT } from '../i18n/index.js';

export function MoveNotice() {
  const t = useT();
  const [state, setState] = useState<MoveState | null>(null);

  useEffect(() => {
    let alive = true;
    const check = async () => {
      const s = await moveIfRehomed(() => db.outbox.count(), thisShop()?.code);
      if (alive) setState(s && s.waiting > 0 ? s : null);
    };
    void check();
    // Keep asking: the outbox drains on its own once the connection is up.
    const timer = window.setInterval(() => void check(), 20_000);
    return () => {
      alive = false;
      clearInterval(timer);
    };
  }, []);

  if (!state) return null;
  return (
    <div className="move-notice" role="status">
      {t('move.waiting', { host: state.host, n: state.waiting })}
    </div>
  );
}
